<template>
  <v-dialog :value="open" :width="400" persistent>
    <v-card>
      <v-card-title primary-title class="headline primary--text">{{
        $t('edit_member')
      }}</v-card-title>
      <v-card-text>
        <form id="editForm" @submit="handleSubmit">
          <v-container fluid grid-list-lg class="pa-0 ma-0" :style="{ width: '100% !important' }">
            <v-layout wrap>
              <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('employee_id') }">
                <label class="caption">{{ $t('employee_id_abbr') }}</label>
                <input
                  v-model="form.employee_id"
                  v-validate="'required'"
                  name="employee_id"
                  type="text"
                  :disabled="isLoading"
                  :data-vv-as="$t('employee_id_abbr')"
                />
                <p v-if="errors.has('employee_id')" class="text-error ma-0">
                  {{ errors.first('employee_id') }}
                </p>
              </v-flex>
              <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('first_name') }">
                <label class="caption">{{ $t('first name') }}</label>
                <input
                  v-model="form.first_name"
                  v-validate="'required'"
                  name="first_name"
                  type="text"
                  :disabled="isLoading"
                  :data-vv-as="$t('first name')"
                />
                <p v-if="errors.has('first_name')" class="text-error ma-0">
                  {{ errors.first('first_name') }}
                </p>
              </v-flex>
              <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('last_name') }">
                <label class="caption">{{ $t('surname') }}</label>
                <input
                  v-model="form.last_name"
                  v-validate="'required'"
                  name="last_name"
                  type="text"
                  :disabled="isLoading"
                  :data-vv-as="$t('surname')"
                />
                <p v-if="errors.has('last_name')" class="text-error ma-0">
                  {{ errors.first('last_name') }}
                </p>
              </v-flex>
              <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('position') }">
                <label class="caption">{{ $t('position') }}</label>
                <multiselect
                  v-model="form.position"
                  v-validate="'required'"
                  name="position"
                  :disabled="isLoading"
                  :data-vv-as="$t('surname')"
                  :options="positionOptions()"
                  label="label"
                  track-by="value"
                  :allow-empty="false"
                  :searchable="false"
                  :show-labels="false"
                ></multiselect>
                <p v-if="errors.has('position')" class="text-error ma-0">
                  {{ errors.first('position') }}
                </p>
              </v-flex>
              <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('department') }">
                <label class="caption">{{ $t('department') }}</label>
                <multiselect
                  v-model="form.department"
                  v-validate="'required'"
                  name="department"
                  :disabled="isLoading"
                  :data-vv-as="$t('surname')"
                  :options="departmentOptions()"
                  label="label"
                  track-by="value"
                  :allow-empty="false"
                  :searchable="false"
                  :show-labels="false"
                ></multiselect>
                <p v-if="errors.has('department')" class="text-error ma-0">
                  {{ errors.first('department') }}
                </p>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  v-model="form.consent"
                  :label="$t('terms_and_conditions')"
                  color="primary"
                  hide-details
                  class="ma-0 pa-0"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions :style="{ justifyContent: 'center' }">
        <v-btn outline color="grey" :disabled="isLoading" @click="$emit('update:open', false)">{{
          $t('cancel')
        }}</v-btn>
        <v-btn color="primary" :loading="isLoading" type="submit" form="editForm">{{
          $t('Save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import tigerpolyApi from '@/api/tigerpoly'

export default {
  components: { Multiselect },
  inject: ['positionOptions', 'departmentOptions'],
  props: {
    value: {
      type: Object,
      default: null
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        employee_id: '',
        first_name: '',
        last_name: '',
        position: null,
        department: null,
        consent: false
      },
      isLoading: false
    }
  },
  watch: {
    open(value) {
      if (value) {
        if (this.value) {
          this.form = {
            employee_id: this.value.employee_id,
            first_name: this.value.first_name,
            last_name: this.value.last_name,
            position:
              this.positionOptions().find((option) => option.value === this.value.position) || null,
            department:
              this.departmentOptions().find((option) => option.value === this.value.department) ||
              null,
            consent: this.value.consent
          }
        }
        this.isLoading = false
        this.$validator.reset()
      }
    }
  },
  methods: {
    async handleSubmit(event) {
      event.preventDefault()

      const isValid = await this.$validator.validate()

      if (!this.value || !isValid) return

      try {
        this.isLoading = true

        const response = await tigerpolyApi.putMember({
          data: {
            id: this.value.id,
            page_id: this.value.page_id,
            ...this.form,
            position: this.form.position.value,
            department: this.form.department.value
          }
        })

        if (response.status === 204) {
          this.$emit('success')
        }
      } catch (error) {
        this.isLoading = false

        if (error.response.data) {
          this.$swal.fire(error.response.data.message, undefined, 'error')
        }
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/member/EditFormDialog.vue